import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
import { Container, Grid, Card, CardContent, Typography, Button, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../AuthContext';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/');
      return;
    }
    fetchUsers();
  }, [currentUser, navigate]);


  const changeBodyBackground = (background) => {
    document.body.style.background = background;
  };


  useEffect(() => {
    changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
    return () => changeBodyBackground(''); // Reset background on unmount
  }, []);

  const fetchUsers = async () => {
    const usersCollection = await getDocs(collection(db, 'users'));
    const usersData = usersCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setUsers(usersData);
  };

  const handleClickOpen = (user) => {
    setSelectedUser(user);
    setUsername(user.username || '');
    setPassword(user.password || '');
    setRole(user.role || '');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUser(null);
  };

  const handleSave = async () => {
    try {
      if (selectedUser && selectedUser.id) {
        const userDoc = doc(db, 'users', selectedUser.id);
        await updateDoc(userDoc, {
          username,
          password,
          role,
        });
      } else {
        await addDoc(collection(db, 'users'), {
          username,
          password,
          role,
        });
      }
      fetchUsers();
      handleClose();
    } catch (error) {
      console.error("Error saving user: ", error);
    }
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'users', id));
    fetchUsers();
  };

  const roleOptions = {
    orderManager: 'מנהל הזמנות',
    warehouseManager: 'מנהל מחסן',
    user: 'משתמש',
    admin: 'מנהל מערכת',
  };

  const getRoleLabel = (role) => roleOptions[role] || '';

  return (
    <Container sx={{ paddingTop: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="contained" color="primary" onClick={() => handleClickOpen({})}>הוסף משתמש</Button>
      </Box>

      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Grid container spacing={2} alignItems="center">
          {users.map(user => (
            <Grid item xs={12} sm={6} md={4} key={user.id}>
              <Card sx={{ width: '100%', backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative', margin: '0 auto' }}>
                <CardContent>
                  <Typography variant="h6">{user.username}</Typography>
                  <Typography variant="body2">{getRoleLabel(user.role)}</Typography>
                </CardContent>
                <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpen(user)} sx={{ marginTop: '10px', marginRight: '5px', marginLeft: '5px' }}>ערוך</Button>
                <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(user.id)} sx={{ marginTop: '10px' }}>מחק</Button>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedUser ? 'ערוך משתמש' : 'הוסף משתמש'}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            label="שם משתמש"
            type="text"
            fullWidth
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <TextField
            margin="dense"
            label="סיסמה"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <FormControl fullWidth sx={{ marginBottom: '20px' }}>
            <InputLabel id="role-label">תפקיד</InputLabel>
            <Select
              labelId="role-label"
              value={role}
              label="תפקיד"
              onChange={(e) => setRole(e.target.value)}
            >
              <MenuItem value="orderManager">מנהל הזמנות</MenuItem>
              <MenuItem value="warehouseManager">מנהל מחסן</MenuItem>
              <MenuItem value="user">משתמש</MenuItem>
              <MenuItem value="admin">מנהל מערכת</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">ביטול</Button>
          <Button onClick={handleSave} color="primary">שמור</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ManageUsers;
